<script setup>
import InscriptionForm from '@/components/InscriptionForm.vue'
import roleCheckMixin from "@/mixins/roleCheckMixin";
</script>

<template>
  <h1>Ajouter un compte</h1>
  <div class="inscription container">
   
    <InscriptionForm />
  </div>
</template>

<script>
 
export default {
    mixins: [roleCheckMixin],
 }
</script>

<style>
@media (min-width: 1024px) {
  .about {
    min-height: 100vh;
    display: flex;
    align-items: center;
  }
}
</style>
